export class ChangepasswordDto {
  oldPassword: string;
  newPassword: string; 
}
